import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Button,
  CssBaseline,
  Paper,
  CircularProgress,
} from "@mui/material";
import { H1, Small } from "../../components/Typography";
import { save } from "../../constants/storage";
import { useNavigate, useLocation } from "react-router-dom";
import { MuiOtpInput } from "mui-one-time-password-input";
import Carousel from "react-material-ui-carousel";
import { OTPVerifyRequest, ResendOTPVerifyRequest } from "../../models";
import { spalshItems } from "../../constants/constant";
import { useAppDispatch } from "../../store/hooks";
import { resendOTP, verifyOTP } from "../../redux/actions/LoginAction";
import toast from "react-hot-toast";

export default function Otp() {
  let navigate = useNavigate();
  let routeData = useLocation();
  const dispatch = useAppDispatch();
  const { number, partnerCode } = routeData.state;
  const [isLoaded, setIsLoaded] = useState(false);

  const [otp, setOtp] = React.useState("");

  const handleChange = (newValue: any) => {
    setOtp(newValue);
  };
  useEffect(() => {
    const preloadImages = () => {
      const imagePromises = spalshItems.map((item) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = item.image;
          img.onload = resolve;
          img.onerror = reject;
        });
      });

      Promise.all(imagePromises)
        .then(() => {
          setIsLoaded(true);
        })
        .catch((error) => {
          setIsLoaded(true); // Set isLoaded to true even if there was an error to prevent blocking the UI
        });
    };

    preloadImages();
  }, []);

  const handleSubmit = () => {
    const data: OTPVerifyRequest = {
      mobile: number,
      otp: otp,
      partner: partnerCode === "0" ? partnerCode : "",
      pid: partnerCode === "0" ? "" : partnerCode,
    };

    dispatch(verifyOTP(data))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          toast.error(response.message);
          setOtp("");
          return;
        }
        delete response?.data[0].device_info;
        if (response.statusCode === 200) {
          save(
            "userName",
            response?.data[0].firstname + " " + response?.data[0].lastname
          );
          save("tabState", "1");
          save("token", response.token);
          save("userData", JSON.stringify(response?.data[0]));
          if (response?.data[0]?.user_status === "UNREGISTERED") {
            navigate("/register", { state: { partnerCode } });
          } else {
            navigate("/dashboard", { state: { justLoggedIn: true } });
          }
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const onResendEvent = () => {
    const data: ResendOTPVerifyRequest = {
      mobile: number,
      partner: partnerCode,
      terms_accepted: true,
      hashCode: "",
    };

    dispatch(resendOTP(data))
      .then(async (response: any) => {
        if (response.statusCode === 400) {
          toast.error(response.message);
          setOtp("");
          return;
        }
        if (response.statusCode === 200) {
          toast.success(response.data.message);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const onEditEvent = () => {
    navigate("/login");
  };

  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
        alignItems: "center",
        display: "flex",
      }}
    >
      <CssBaseline />
      {/* Left Side  */}
      <Grid item xs={false} sm={4} md={6} sx={sxStyleGrid}>
        {partnerCode === "0" ? (
          <Box sx={sxStyleBoxCaresoul}>
            {isLoaded ? (
              <Carousel animation="slide">
                {spalshItems?.map((item) => (
                  <Box key={item.id}>
                    <Grid sx={sxStyleGridCaresoul}>
                      <Box
                        component="img"
                        src={item.image}
                        sx={sxStyleImageCaresoul}
                      />
                    </Grid>
                  </Box>
                ))}
              </Carousel>
            ) : (
              <Grid
                height="70vh"
                display="flex"
                flexDirection="column"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <CircularProgress />
              </Grid>
            )}
          </Box>
        ) : (
          <Box sx={sxStyleBoxCaresoulPartner}>
            {isLoaded ? (
              <Carousel animation="slide">
                {spalshItems?.map((item) => (
                  <Box key={item.id}>
                    <Grid sx={sxStyleGridCaresoul}>
                      <Box
                        component="img"
                        src={item.image}
                        sx={sxStyleImageCaresoul}
                      />
                    </Grid>
                  </Box>
                ))}
              </Carousel>
            ) : (
              <Grid
                height="70vh"
                display="flex"
                flexDirection="column"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                }}
              >
                <CircularProgress />
              </Grid>
            )}
            <Box
              sx={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                sx={{
                  height: {
                    xs: "10%",
                    sm: "10%",
                    md: "25%",
                  },
                  width: {
                    xs: "17%",
                    sm: "17%",
                    md: "35%",
                  },
                  mt: 5,
                }}
                src={process.env.REACT_APP_PARTNERSHIP}
                alt="saas-dasboard-footer"
              />
            </Box>
          </Box>
        )}
      </Grid>

      {/* Right Side */}
      <Grid item xs={12} sm={4} md={6} component={Paper} sx={sxStyleGrid1}>
        <Grid md={10} sx={sxStyleBox}>
          <Grid
            sx={{
              justifyContent: {
                md: "flex-start",
                sm: "flex-start",
                xs: "center",
              },
              alignItems: "center",
              display: "flex",
            }}
          >
            <Box
              component="img"
              src={process.env.REACT_APP_LOGO}
              sx={sxStyleBoxImage}
            />
          </Grid>
          <Grid
            sx={{
              justifyContent: {
                md: "flex-start",
                sm: "flex-start",
                xs: "center",
              },
              alignItems: "center",
              display: "flex",
            }}
          >
            <Box
              flexDirection="column"
              display="flex"
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/newOtpImage.svg"
              sx={sxStyleImage1}
            />
          </Grid>

          <H1
            fontSize={24}
            fontWeight={600}
            sx={sxStyleH1}
            color={process.env.REACT_APP_PRIMARY_COLOR}
          >
            Enter OTP
          </H1>
          <Small fontWeight={300} sx={sxStyleSmall} color="#595959">
            Sent to your registered mobile No.
          </Small>
          <Grid sx={sxStyleGrid3}>
            <Small fontSize={16} sx={sxStyleSmall1}>
              +91-{number}
            </Small>
            <Box
              onClick={onEditEvent}
              component="img"
              src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/editIcon.svg"
              sx={sxStyleBoxImage1}
            />
          </Grid>
          <Box sx={sxStyleBox1}>
            <Box sx={sxStyleBox2}>
              <MuiOtpInput
                sx={styleOtpBox}
                value={otp}
                autoFocus
                onChange={handleChange}
              />
            </Box>
            <Button
              onClick={() => handleSubmit()}
              type="submit"
              variant="contained"
              size="medium"
              sx={[sxStyleButton, { textTransform: "none" }]}
            >
              Validate OTP
            </Button>
            <Grid onClick={onResendEvent} sx={sxStyleGrid2}>
              <Small
                fontSize={18}
                sx={{
                  cursor: "pointer",
                  textAlign: "center",
                  maxWidth: {
                    xs: "100%",
                    sm: "100%",
                    md: "100%",
                  },
                  fontFamily: "'Poppins', sans-serif",
                  color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                }}
              >
                Resend OTP
              </Small>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}

// Define a custom form container using styled()
const sxStyleGrid = {
  backgroundRepeat: "no-repeat",
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  backgroundSize: "cover",
  backgroundPosition: "center",
  maxWidth: {
    xs: "0%",
    sm: "0%",
    md: "80%",
  },
  height: "100vh",
};
const sxStyleGrid1 = {
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  height: "100vh",
};
const sxStyleGrid2 = {
  textAlign: "center",
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: "100%",
  },
  mb: { xs: "0%", sm: "25%", md: '"25%' },
  fontFamily: "'Poppins', sans-serif",
};
const sxStyleGrid3 = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  mt: 1,
};
const styleOtpBox = {
  display: "flex",
  gap: {
    xs: 1,
    sm: 2,
    md: 3,
  },
  marginInline: "auto",
};
const sxStyleBox = {
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: "95%",
  },
  my: 0,
  mx: {
    xs: 1,
    sm: 1,
    md: -4,
  },
  background: "#fff",
  borderRadius: 5,
  paddingX: { xs: 1, md: 4, sm: 4 },
  paddingY: 5,
  boxShadow: {
    xs: 0,
    sm: 2,
    md: 3,
  },
};
const sxStyleBoxImage = {
  width: {
    xs: "30%",
    sm: "60%",
    md: "20%",
  },
  mb: 4,
  alignSelf: "center",
};
const sxStyleBoxImage1 = {
  cursor: "pointer",
  height: {
    xs: "5%",
    sm: "5%",
    md: "3%",
  },
  width: {
    xs: "5%",
    sm: "5%",
    md: "3%",
  },
};
const sxStyleH1 = {
  mt: { md: 3, sm: 3, xs: 3 },
  textAlign: "left",
  fontFamily: "'Poppins', sans-serif",
};
const sxStyleSmall = {
  textAlign: "left",
  width: "100%",
  fontFamily: "'Poppins', sans-serif",
};

const sxStyleBoxCaresoul = {
  maxWidth: {
    xs: "0%",
    sm: "0%",
    md: "90%",
  },
  my: 8,
  mx: {
    xs: 0,
    sm: 0,
    md: 4,
  },
  background: "transaparent",
  paddingX: 4,
  paddingY: 0,
};

const sxStyleBoxCaresoulPartner = {
  maxWidth: {
    xs: "0%",
    sm: "0%",
    md: "80%",
  },
  my: 4,
  mx: {
    xs: 0,
    sm: 0,
    md: 4,
  },
  background: "transaparent",
  paddingX: 4,
  paddingY: 5,
};
const sxStyleImageCaresoul = {
  height: {
    xs: "30%",
    sm: "30%",
    md: "5%",
  },
  width: {
    xs: "100%",
    sm: "100%",
    md: "70%",
  },
  marginBottom: 4,
};
const sxStyleSmall1 = {
  textAlign: "center",
  maxWidth: {
    xs: "100%",
    sm: "100%",
    md: "100%",
  },
  mr: 1,
  fontFamily: "'Poppins', sans-serif",
  color: "#595959",
};

const sxStyleGridCaresoul = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
};
const sxStyleBox1 = {
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  display: "flex",
  mt: 2,
};
const sxStyleBox2 = {
  width: "60%",
  flexDirection: "row",
  display: "flex",
  alignItems: "center",
};

const sxStyleButton = {
  mt: 3,
  mb: 2,
  py: 1,
  fontFamily: "'Poppins', sans-serif",
  width: {
    xs: "100%",
    sm: "100%",
    md: "60%",
  },
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
};
const sxStyleImage1 = {
  width: {
    xs: "50%",
    sm: "60%",
    md: "20%",
    mt: { xs: 1, sm: 0, md: 0 },
  },
  display: {
    sm: "none",
    md: "none",
    xs: "flex",
  },
  marginBottom: 3,
};
